import { render, staticRenderFns } from "./BiddingReserveNotMet.vue?vue&type=template&id=95c52b70&scoped=true"
import script from "./BiddingReserveNotMet.vue?vue&type=script&lang=js"
export * from "./BiddingReserveNotMet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c52b70",
  null
  
)

export default component.exports